import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const GeneratorSwitchButtonTrueIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Group 29613604">
        <circle
          id="Ellipse 1219"
          cx="5.11475"
          cy="5"
          r="4.42063"
          fill={fillColor || '#D3481C'}
          stroke="url(#paint0_linear_313_13658)"
          strokeWidth="0.84127"
        />
        <ellipse id="Ellipse 1265" opacity="0.4" cx="5.115" cy="3.36798" rx="2.22877" ry="1.78302" fill="url(#paint1_linear_313_13658)" />
      </g>
      <defs>
        <linearGradient id="paint0_linear_313_13658" x1="5.11475" y1="1" x2="4.15256" y2="7.31433" gradientUnits="userSpaceOnUse">
          <stop stopColor="#191A1B" stopOpacity="0" />
          <stop offset="1" stopColor="#191A1B" stopOpacity="0.15" />
        </linearGradient>
        <linearGradient id="paint1_linear_313_13658" x1="5.115" y1="5.151" x2="5.115" y2="1.58496" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export { GeneratorSwitchButtonTrueIcon };
